import { render, staticRenderFns } from "./DuelsReel.vue?vue&type=template&id=5365d7ca"
import script from "./DuelsReel.vue?vue&type=script&lang=js"
export * from "./DuelsReel.vue?vue&type=script&lang=js"
import style0 from "./DuelsReel.vue?vue&type=style&index=0&id=5365d7ca&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports